import React from 'react';

const StatisticsIcon = ({
  width = '16',
  height = '16',
  fill = '#007AFF',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_631_16513)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3.1C1 2.54305 1.22125 2.0089 1.61508 1.61508C2.0089 1.22125 2.54305 1 3.1 1L12.9 1C13.457 1 13.9911 1.22125 14.3849 1.61508C14.7788 2.0089 15 2.54305 15 3.1V12.9C15 13.457 14.7788 13.9911 14.3849 14.3849C13.9911 14.7788 13.457 15 12.9 15H3.1C2.54305 15 2.0089 14.7788 1.61508 14.3849C1.22125 13.9911 1 13.457 1 12.9V3.1ZM10.2316 11.675C10.2316 11.9071 10.3238 12.1296 10.4879 12.2937C10.652 12.4578 10.8745 12.55 11.1066 12.55C11.3387 12.55 11.5612 12.4578 11.7253 12.2937C11.8894 12.1296 11.9816 11.9071 11.9816 11.675V4.325C11.9816 4.09294 11.8894 3.87038 11.7253 3.70628C11.5612 3.54219 11.3387 3.45 11.1066 3.45C10.8745 3.45 10.652 3.54219 10.4879 3.70628C10.3238 3.87038 10.2316 4.09294 10.2316 4.325V11.675ZM8 12.55C7.517 12.55 7.125 12.158 7.125 11.675V7.3434C7.125 7.11134 7.21719 6.88878 7.38128 6.72468C7.54538 6.56059 7.76794 6.4684 8 6.4684C8.23206 6.4684 8.45462 6.56059 8.61872 6.72468C8.78281 6.88878 8.875 7.11134 8.875 7.3434V11.675C8.875 12.158 8.483 12.55 8 12.55ZM4.0184 11.675C4.0184 11.9071 4.11059 12.1296 4.27468 12.2937C4.43878 12.4578 4.66134 12.55 4.8934 12.55C5.12546 12.55 5.34802 12.4578 5.51212 12.2937C5.67621 12.1296 5.7684 11.9071 5.7684 11.675V8.7868C5.7684 8.55474 5.67621 8.33218 5.51212 8.16808C5.34802 8.00399 5.12546 7.9118 4.8934 7.9118C4.66134 7.9118 4.43878 8.00399 4.27468 8.16808C4.11059 8.33218 4.0184 8.55474 4.0184 8.7868V11.675Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_631_16513">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="matrix(-1 0 0 1 15 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default StatisticsIcon;
